<header class="topbar">
  <div class="topbar-left">
    <button class="mobile-menu-btn" type="button" (click)="toggleMobileMenu()" aria-label="Abrir menu">
      <mat-icon>{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
    <button class="topbar-icon action" type="button" *ngIf="!isMobileViewport && canViewModule('controltask')" (click)="openTaskModal()">
      <mat-icon>playlist_add</mat-icon>
    </button>
    <button
      class="topbar-icon action"
      type="button"
      *ngIf="!isMobileViewport && canViewModule('controlhelp')"
      routerLink="/controlhelp"
      (click)="clearControlhelpUpdates()">
      <mat-icon>support_agent</mat-icon>
      <span class="notification-dot" *ngIf="controlhelpHasUpdates"></span>
    </button>
    <button
      class="topbar-icon action"
      type="button"
      *ngIf="canViewModule('controlbordo')"
      (click)="openBordoEntry()">
      <mat-icon>note_alt</mat-icon>
    </button>
    <button
      class="topbar-icon action"
      type="button"
      *ngIf="!isMobileViewport && isMasterProfile"
      (click)="openFieldsLabModal()"
      aria-label="Validar campos">
      <mat-icon>fact_check</mat-icon>
    </button>
    <button
      class="topbar-icon action"
      type="button"
      *ngIf="!isMobileViewport && isMainTenant"
      (click)="openMonitoringPage()"
      aria-label="Monitoramento do sistema">
      <mat-icon>monitoring</mat-icon>
    </button>
    <div class="topbar-metas" *ngIf="!isMobileViewport">
      <div class="weather">
        <mat-icon>{{ weatherIcon }}</mat-icon>
        <div class="weather-text">
          <span class="city">{{ weatherCity }}</span>
          <span class="temp">{{ weatherTempLabel }} · {{ weatherRangeLabel }}</span>
        </div>
      </div>
      <div class="topbar-module-search" #moduleSearchRef>
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [ngModel]="moduleSearchTerm"
          (ngModelChange)="onModuleSearchInput($event)"
          (focus)="onModuleSearchFocus()"
          placeholder="Buscar módulo..."
          aria-label="Buscar módulo habilitado">
        <div class="module-search-results" *ngIf="moduleSearchOpen">
          <button
            type="button"
            class="module-search-item"
            *ngFor="let item of moduleSearchResults"
            (click)="selectModuleResult(item)">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.label }}</span>
          </button>
          <div class="module-search-empty" *ngIf="!moduleSearchResults.length">
            Nenhum módulo encontrado.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="topbar-right">
    <div class="user-block">
      <span class="greeting">Olá, {{ userInfo?.displayName || 'Usuário' }}</span>
      <small class="user-meta">
        Ambiente: {{ userInfo?.tenantName || '—' }} ·
        Perfil: {{ userInfo?.roleName || '—' }}
      </small>
    </div>
    <button class="avatar" type="button" (click)="toggleAvatarMenu($event)">
      {{ userInfo?.initials || 'U' }}
    </button>
    <div class="avatar-menu" *ngIf="avatarMenuOpen" (click)="$event.stopPropagation()">
      <button type="button" *ngIf="isMasterProfile" (click)="openDesktopDownload()">Download desktop</button>
      <button type="button" *ngIf="isMasterProfile" (click)="toggleLanguage()">{{ 'UI.LANGUAGE' | translate }}: {{ languageLabel }}</button>
      <button type="button" class="danger" (click)="logout()">Sair</button>
    </div>
  </div>
</header>

<nav class="sidemenu" [class.closed]="isClosed" [class.scrollable]="menuScrollable" [class.mobile-open]="mobileMenuOpen" (mouseenter)="onMenuMouseEnter()" (mouseleave)="onMenuMouseLeave()">
    <ul #menuListRef (scroll)="onMenuListScroll()">
        <li class="menu-logo-item">
            <img class="logo-menu" src="../../../assets/MIV/brand/versao 4.png" width="40px" alt="">
            <span class="logo"></span>
            <button class="mobile-close-btn" type="button" (click)="closeMobileMenu()" aria-label="Fechar menu">
              <mat-icon>close</mat-icon>
            </button>
        </li>
        <li class="menu-list" *ngIf="canViewModule('home')" routerLink="/feed" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-label="Home"><mat-icon>home</mat-icon><span class="text">Home</span></li>
        <li class="menu-list intranet" *ngIf="canViewModule('intranet')" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }" (click)="toggleIntranet($event)" data-label="Intranet">
          <mat-icon>cloud</mat-icon>
          <span class="text">Intranet</span>
          <mat-icon class="chevron" *ngIf="!isClosed">{{ intranetOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </li>
        <li class="menu-list intranet-child" *ngIf="intranetOpen && canViewModule('intranet')" routerLink="/feed" routerLinkActive="active" data-label="Feed">
          <mat-icon>rss_feed</mat-icon><span class="text">Feed</span>
        </li>
        <li class="menu-list intranet-child" *ngIf="intranetOpen && canCreateOrManage('intranet')" routerLink="/intranet-dash" routerLinkActive="active" data-label="Dashboard">
          <mat-icon>dashboard</mat-icon><span class="text">Dashboard</span>
        </li>
        <li class="menu-list" *ngIf="canViewModule('cadastros')" routerLink="/cadastros" routerLinkActive="active" data-label="Cadastros"><mat-icon>assignment</mat-icon><span class="text">Cadastros</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlsign')" routerLink="/controlsign" routerLinkActive="active" data-label="ControlSign"><mat-icon>picture_as_pdf</mat-icon><span class="text">ControlSign</span></li>
        <li class="menu-list" *ngIf="canViewModule('controltask')" routerLink="/controltask" routerLinkActive="active" data-label="ControlTask"><mat-icon>check_circle</mat-icon><span class="text">ControlTask</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlproject')" routerLink="/controlproject" routerLinkActive="active" data-label="ControlProject"><mat-icon>work_outline</mat-icon><span class="text">ControlProject</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlflow')" routerLink="/controlflow" routerLinkActive="active" data-label="ControlFlow"><mat-icon>schema</mat-icon><span class="text">ControlFlow</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlhelp')" routerLink="/controlhelp" routerLinkActive="active" data-label="ControlHelp"><mat-icon>support_agent</mat-icon><span class="text">ControlHelp</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlbordo')" routerLink="/controlbordo" routerLinkActive="active" data-label="Diario de Bordo"><mat-icon>note_alt</mat-icon><span class="text">Diario de Bordo</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlcli')" routerLink="/controlcli" routerLinkActive="active" data-label="ControlCLI"><mat-icon>shopping_bag</mat-icon><span class="text">ControlCLI</span></li>
        <li class="menu-list" *ngIf="canViewModule('controldocs')" routerLink="/controldocs" routerLinkActive="active" data-label="ControlDocs"><mat-icon>folder</mat-icon><span class="text">ControlDocs</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlsafe')" routerLink="/controlsafe" routerLinkActive="active" data-label="ControlSafe"><mat-icon>lock</mat-icon><span class="text">ControlSafe</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlmentor')" routerLink="/controlmentor" routerLinkActive="active" data-label="ControlMentor"><mat-icon>diversity_3</mat-icon><span class="text">ControlMentor</span></li>
        <li class="menu-list" *ngIf="canViewModule('controldp')" routerLink="/controldp" routerLinkActive="active" data-label="ControlDP"><mat-icon>badge</mat-icon><span class="text">ControlDP</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlop')" routerLink="/controlop" routerLinkActive="active" data-label="ControlOP"><mat-icon>settings_suggest</mat-icon><span class="text">ControlOP</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlquestion')" routerLink="/controlquestion" routerLinkActive="active" data-label="ControlQuestion"><mat-icon>quiz</mat-icon><span class="text">ControlQuestion</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlai')" routerLink="/controlai" routerLinkActive="active" data-label="ControlAI"><mat-icon>smart_toy</mat-icon><span class="text">ControlAI</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlsocial')" routerLink="/controlsocial" routerLinkActive="active" data-label="ControlSocial"><mat-icon>forum</mat-icon><span class="text">ControlSocial</span></li>
        <li class="menu-list" *ngIf="canViewModule('controlinventory')" routerLink="/controlinventory" routerLinkActive="active" data-label="ControlInventory"><mat-icon>inventory_2</mat-icon><span class="text">ControlInventory</span></li>
        <li class="menu-list" *ngIf="canViewModule('mystore')" routerLink="/mystore" routerLinkActive="active" data-label="My Store"><mat-icon>storefront</mat-icon><span class="text">My Store</span></li>
        <li class="menu-list" *ngIf="canViewModule('controldossie') && (isMasterOnlyProfile || isMasterProfile)" routerLink="/controldossie" routerLinkActive="active" data-label="ControlDossie"><mat-icon>folder_special</mat-icon><span class="text">ControlDossie</span></li>
    </ul>
</nav>

<div class="cp-modal-backdrop" *ngIf="showFieldsLabModal" (click)="closeFieldsLabModal()"></div>
<section class="cp-modal cp-modal-fixed-height cp-fields-lab-modal" *ngIf="showFieldsLabModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Guia de execução</h2>
      <small>Padrão global dos campos e guia de deploy para produção.</small>
    </div>
    <button class="icon" type="button" (click)="closeFieldsLabModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="cp-modal-body" (submit)="$event.preventDefault()">
    <nav class="cp-tabs cp-fields-lab-tabs">
      <button
        *ngFor="let tab of fieldsLabTabs"
        type="button"
        [class.active]="fieldsLabTab === tab.value"
        (click)="setFieldsLabTab(tab.value)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        {{ tab.label }}
      </button>
    </nav>

    <div class="cp-modal-scroll">
      <section class="cp-panel">
        <div class="cp-fields-lab-grid" [ngSwitch]="fieldsLabTab">
          <ng-container *ngSwitchCase="'inputs'">
            <div class="cp-field-demo full">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Input</mat-label>
                <input matInput type="text" [(ngModel)]="fieldsLabForm.inputValue" name="fields_lab_input">
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field`</small>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'select'">
            <div class="cp-field-demo">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Select (single)</mat-label>
                <mat-select [(ngModel)]="fieldsLabForm.selectValue" name="fields_lab_select">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let option of fieldsLabSelectOptions" [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field`</small>
            </div>
            <div class="cp-field-demo">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Select (multiple)</mat-label>
                <mat-select
                  multiple
                  [(ngModel)]="fieldsLabForm.multiSelectValues"
                  (ngModelChange)="onFieldsLabMultiSelectChange($event)"
                  name="fields_lab_select_multiple">
                  <mat-option [value]="fieldsLabSelectAllValue">Selecionar todos</mat-option>
                  <mat-option *ngFor="let option of fieldsLabSelectOptions" [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field` + `mat-select[multiple]`</small>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'textarea'">
            <div class="cp-field-demo full">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
                <mat-label>Textarea</mat-label>
                <textarea matInput rows="4" [(ngModel)]="fieldsLabForm.textareaValue" name="fields_lab_textarea"></textarea>
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field`</small>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'date'">
            <div class="cp-field-demo">
              <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
                <mat-label>Data</mat-label>
                <input
                  matInput
                  type="text"
                  name="fields_lab_date"
                  placeholder="dd/mm/aaaa"
                  inputmode="numeric"
                  maxlength="10"
                  [ngModel]="fieldsLabForm.dateValue"
                  (ngModelChange)="onFieldsLabDateInput($event)"
                  (blur)="onFieldsLabDateBlur()">
                <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário" (click)="fieldsLabDatePicker.open()">
                  <mat-icon>calendar_today</mat-icon>
                </button>
                <mat-error *ngIf="fieldsLabDateInvalid">Data inválida</mat-error>
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field`</small>
            </div>
            <div class="cp-field-demo">
              <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
                <mat-label>Data e hora</mat-label>
                <input
                  matInput
                  type="text"
                  name="fields_lab_datetime"
                  placeholder="dd/mm/aaaa, hh:mm"
                  inputmode="numeric"
                  maxlength="17"
                  [ngModel]="fieldsLabForm.dateTimeValue"
                  (ngModelChange)="onFieldsLabDateTimeInput($event)"
                  (blur)="onFieldsLabDateTimeBlur()">
                <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de data e hora" (click)="fieldsLabDateTimePicker.open()">
                  <mat-icon>calendar_today</mat-icon>
                </button>
                <mat-error *ngIf="fieldsLabDateTimeInvalid">Data e hora inválidas</mat-error>
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field`</small>
            </div>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="fieldsLabDatePicker"
              [ngModel]="fieldsLabDatePickerValue"
              (dateChange)="onFieldsLabDatePicked($event)"
              name="fields_lab_date_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #fieldsLabDatePicker></mat-datepicker>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="fieldsLabDateTimePicker"
              [ngModel]="fieldsLabDateTimePickerValue"
              (dateChange)="onFieldsLabDateTimePicked($event)"
              name="fields_lab_datetime_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #fieldsLabDateTimePicker></mat-datepicker>
          </ng-container>

          <ng-container *ngSwitchCase="'search'">
            <div class="cp-field-demo">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field">
                <mat-label>Pesquisa</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" [(ngModel)]="fieldsLabForm.searchValue" name="fields_lab_search">
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field.cp-search-field`</small>
            </div>
            <div class="cp-field-demo">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table">
                <mat-label>Pesquisa <span class="cp-field-usage-tag">Tabela</span></mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input
                  matInput
                  type="text"
                  placeholder="Pesquise o colaborador..."
                  [(ngModel)]="fieldsLabForm.tableSearchValue"
                  name="fields_lab_search_table">
              </mat-form-field>
              <small class="cp-field-class-name">Classe: `.digital-field.modal-standard-field.cp-search-field.cp-search-field--table`</small>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'buttons'">
            <div class="cp-field-demo full cp-fields-lab-buttons">
              <div class="cp-fields-lab-button-row">
                <button mat-stroked-button type="button">Cancelar</button>
                <button mat-flat-button color="primary" type="button">Salvar alterações</button>
              </div>
              <div class="cp-fields-lab-button-row">
                <button mat-stroked-button type="button">
                  <mat-icon>auto_awesome</mat-icon>
                  Preencher automaticamente
                </button>
                <button mat-flat-button color="primary" type="button">
                  <mat-icon>add</mat-icon>
                  Novo
                </button>
              </div>
              <small class="cp-field-class-name">Classes: `[mat-stroked-button]`, `[mat-flat-button][color="primary"]`</small>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'icons'">
            <div class="cp-field-demo full">
              <div class="cp-fields-lab-icons-grid">
                <div class="cp-fields-lab-icon-item" *ngFor="let iconName of fieldsLabIconCatalog">
                  <mat-icon>{{ iconName }}</mat-icon>
                  <code>{{ iconName }}</code>
                </div>
              </div>
              <small class="cp-field-class-name">Uso: `<mat-icon>nome_do_icone</mat-icon>`</small>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'deploy'">
            <div class="cp-field-demo full cp-deploy-guide">
              <h3>Deploy para produção</h3>
              <p class="cp-deploy-guide-intro">
                Execute um comando por vez. Primeiro no ambiente DEV (local), depois no ambiente PROD (SSH).
              </p>

              <div class="cp-deploy-guide-block">
                <h4>1. DEV: preparar e enviar código</h4>
                <ol>
                  <li>
                    <strong>Entrar no projeto</strong>
                    <p>Garante que os comandos serão executados no repositório correto.</p>
                    <pre><code>cd /Users/piezentini/Documents/controlps</code></pre>
                  </li>
                  <li>
                    <strong>Validar mudanças pendentes</strong>
                    <p>Confere arquivos alterados antes de versionar.</p>
                    <pre><code>git status</code></pre>
                  </li>
                  <li>
                    <strong>Adicionar arquivos de código</strong>
                    <p>Inclui backend, frontend e dependências no commit.</p>
                    <pre><code>git add backend src package.json package-lock.json</code></pre>
                  </li>
                  <li>
                    <strong>Criar commit</strong>
                    <p>Registra alterações com mensagem objetiva.</p>
                    <pre><code>git commit -m "ajustes gerais do sistema"</code></pre>
                  </li>
                  <li>
                    <strong>Enviar para o repositório remoto</strong>
                    <p>Publica no branch principal para o servidor puxar.</p>
                    <pre><code>git push origin main</code></pre>
                  </li>
                </ol>
              </div>

              <div class="cp-deploy-guide-block">
                <h4>2. PROD (SSH): atualizar aplicação</h4>
                <ol>
                  <li>
                    <strong>Entrar na pasta da aplicação</strong>
                    <pre><code>cd /var/www/controlps_V4</code></pre>
                  </li>
                  <li>
                    <strong>Atualizar código no servidor</strong>
                    <pre><code>git pull origin main</code></pre>
                  </li>
                  <li>
                    <strong>Instalar dependências</strong>
                    <pre><code>npm install</code></pre>
                  </li>
                  <li>
                    <strong>Gerar build</strong>
                    <p>Use produção. Se houver falha de budget, use development.</p>
                    <pre><code>npm run build -- --configuration production</code></pre>
                    <pre><code>npm run build -- --configuration development</code></pre>
                  </li>
                  <li>
                    <strong>Publicar frontend</strong>
                    <pre><code>bash scripts/deploy-frontend.sh</code></pre>
                  </li>
                </ol>
              </div>

              <div class="cp-deploy-guide-block">
                <h4>3. PROD (SSH): validar banco e backend</h4>
                <ol>
                  <li>
                    <strong>Validar túnel local da base</strong>
                    <pre><code>nc -vz 127.0.0.1 3307</code></pre>
                  </li>
                  <li>
                    <strong>Criar túnel se necessário</strong>
                    <pre><code>ssh -o StrictHostKeyChecking=accept-new -fN -L 3307:127.0.0.1:3306 root&#64;72.62.105.164</code></pre>
                  </li>
                  <li>
                    <strong>Reiniciar backend</strong>
                    <pre><code>systemctl restart controlps-backend</code></pre>
                  </li>
                  <li>
                    <strong>Smoke test da API</strong>
                    <p>Retorno esperado: HTTP 200.</p>
                    <pre><code>curl -i "http://localhost:3001/controlhelp/tickets?tenant_id=9"</code></pre>
                  </li>
                </ol>
              </div>

              <div class="cp-deploy-guide-block">
                <h4>4. Pós-deploy (navegador)</h4>
                <ol>
                  <li>Atualizar página com hard refresh (Ctrl/Cmd + Shift + R).</li>
                  <li>Validar login e módulos alterados.</li>
                  <li>Testar fluxos críticos de frontend e backend.</li>
                </ol>
              </div>

              <small class="cp-field-class-name">Referência: guia de deploy operacional DEV + PROD (SSH)</small>
            </div>
          </ng-container>
        </div>

      </section>
    </div>

    <footer class="entry-footer">
      <button type="button" mat-stroked-button (click)="closeFieldsLabModal()">Fechar</button>
    </footer>
  </form>
</section>

<div class="modal-backdrop" *ngIf="showTaskModal">
  <div class="modal-card task-modal">
    <header>
      <h2>Nova tarefa</h2>
      <button class="icon" type="button" (click)="closeTaskModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="taskForm" (ngSubmit)="submitTask()">
      <div class="task-detail-grid">
        <div class="task-main">
          <label>Título
            <input formControlName="title" type="text" placeholder="Resumo da tarefa">
          </label>

          <label>Descrição
            <textarea formControlName="description" rows="3" placeholder="Detalhes adicionais"></textarea>
          </label>

          <div class="form-grid">
            <label>Status
              <select formControlName="status">
                <option value="OPEN">Aberta</option>
                <option value="IN_PROGRESS">Em andamento</option>
                <option value="BLOCKED">Bloqueada</option>
                <option value="COMPLETED">Concluída</option>
                <option value="AWAITING_CLIENT_RESPONSE">Agdo. Retorno Cliente</option>
                <option value="AWAITING_BUDGET_APPROVAL">Agdo. Aprovação de orçamento</option>
                <option value="AWAITING_SUPPLIER_RESPONSE">Agdo. Retorno Fornecedor</option>
              </select>
            </label>
            <label>Visibilidade
              <select formControlName="visibility">
                <option value="PRIVATE">Privada</option>
                <option value="PUBLIC">Pública</option>
              </select>
            </label>
            <label>Prioridade
              <select formControlName="priority">
                <option value="LOW">Baixa</option>
                <option value="MEDIUM">Média</option>
                <option value="HIGH">Alta</option>
                <option value="URGENT">Urgente</option>
              </select>
            </label>
          </div>

          <div class="form-grid">
            <label>Início
              <input type="date" formControlName="start_date">
            </label>
            <label>Vencimento
              <input type="date" formControlName="due_date">
            </label>
          </div>

          <label>Grupos
            <select formControlName="groupId" (change)="handleGroupSelectionChange()">
              <option value="">Selecione</option>
              <option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</option>
            </select>
          </label>

          <label *ngIf="availableFormSubgroups.length">Subgrupo
            <select formControlName="subgroupId" (change)="handleSubgroupSelectionChange()">
              <option value="">Selecione</option>
              <option *ngFor="let subgroup of availableFormSubgroups" [value]="subgroup.id">{{ subgroup.name }}</option>
            </select>
          </label>

          <div class="bucket-field">
            <label>Bucket
              <select formControlName="bucketId" [disabled]="!availableFormBuckets.length">
                <option value="">Selecione</option>
                <option *ngFor="let bucket of availableFormBuckets" [value]="bucket.id">{{ bucket.name }}</option>
              </select>
            </label>
            <p class="inline-hint" *ngIf="!taskForm.get('subgroupId')?.value">
              Selecione um subgrupo para vincular um bucket.
            </p>
            <div class="inline-bucket-form" *ngIf="taskForm.get('subgroupId')?.value && !availableFormBuckets.length">
              <p class="inline-hint">Nenhum bucket encontrado para este subgrupo. Cadastre um novo.</p>
              <label>Nome do novo bucket
                <input type="text" formControlName="inlineBucketName" placeholder="Ex: Backlog">
              </label>
              <label>Descrição (opcional)
                <input type="text" formControlName="inlineBucketDescription" placeholder="Objetivo ou contexto">
              </label>
              <button type="button"
                      class="btn slim"
                      (click)="createInlineBucket()"
                      [disabled]="inlineBucketLoading || !taskForm.get('inlineBucketName')?.value?.trim()">
                {{ inlineBucketLoading ? 'Salvando...' : 'Cadastrar bucket' }}
              </button>
            </div>
          </div>

          <label>Tags
            <select formControlName="tagIds" multiple>
              <option *ngFor="let tag of tags" [value]="tag.id">{{ tag.name }}</option>
            </select>
          </label>

          <label>Responsável
            <select formControlName="assigneeId">
              <option value="">Selecione</option>
              <option *ngFor="let member of members" [value]="member.id">{{ member.name }}</option>
            </select>
          </label>

          <div class="subtask-creator">
            <label>Subtarefas
              <div class="subtask-input-row">
                <input type="text" formControlName="newSubtask" placeholder="Descrição da subtarefa">
                <button type="button" (click)="addDraftSubtask()">Adicionar</button>
              </div>
            </label>
            <ul *ngIf="draftSubtasks.length">
              <li *ngFor="let subtask of draftSubtasks; let i = index">
                {{ subtask }}
                <button type="button" (click)="removeDraftSubtask(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <aside class="task-side-panel">
          <h4>Contexto rápido</h4>
          <p>Defina responsabilidades, datas e etiquetas antes de publicar a tarefa.</p>
          <ul>
            <li><span>Subtarefas</span><strong>{{ draftSubtasks.length }}</strong></li>
            <li><span>Grupo</span><strong>{{ taskForm.value.groupId ? 1 : 0 }}</strong></li>
            <li><span>Etiquetas</span><strong>{{ taskForm.value.tagIds?.length || 0 }}</strong></li>
          </ul>
        </aside>
      </div>

      <footer class="modal-actions">
        <button type="button" class="btn ghost" (click)="closeTaskModal()">Cancelar</button>
        <button type="submit" class="btn primary" [disabled]="taskForm.invalid">Cadastrar tarefa</button>
      </footer>
    </form>
  </div>
</div>
